import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { WorkflowState } from "@rumble-it/common-lib/types/models/WorkflowState.interface";
import { axiosInstance } from "../client";

export async function fetchWorkflowStates(): Promise<
  CollectionResponse<WorkflowState>
> {
  return axiosInstance.get(`workflow/states`).then((response) => response.data);
}
